import { Image, Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const Chapter4Sub9Page = ({ chartImg2, reportData }) => (
  <PDFPage hideTitleDivider reportData={reportData}>
    <View>
      <PDFParagraph>
        {'    '}依照
        <Text style={{ fontWeight: 'bold', fontSize: 20 }}>歷年人數</Text>
        統計之
        <Text>「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」</Text>
        之人數比例橫條圖：
      </PDFParagraph>

      {chartImg2 && <Image src={chartImg2} />}
    </View>
  </PDFPage>
)

export default Chapter4Sub9Page
